import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const BreadthSentimentTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();

    const data = rows.filter(row => row.Category === "BREADTH" || row.Category === "SENTIMENT" || row.Category === "BREADTH_SENTIMENT");

    return <EconomicTable data={data} title="Breadth & Sentiment" defaultRowData={{ Category: "BREADTH_SENTIMENT", Topic: "Breadth" }} groupBy="Topic" groupOrder={["Breadth", "Sentiment"]} useDataHook={useMarketInternalsData} />;
};

export default BreadthSentimentTab;
